<script setup>
import { computed } from "vue";
import {
  PriceComponentType
} from "../../../../interfaces/simulation";
import CostLine from "./CostLine.vue";
const props = defineProps({
  priceDetails: {
    type: Object,
    required: true
  },
  isFree: {
    type: Boolean,
    default: false
  },
  isBoost: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  }
});
const sortedPriceCosts = computed(
  () => [...props.priceDetails.taxedPriceComponents].filter((c) => c.type !== PriceComponentType.TOTAL).sort((a, b) => {
    if (a.type === PriceComponentType.MARGIN) return 1;
    if (b.type === PriceComponentType.MARGIN) return -1;
    return parseFloat(a.price.amount) - parseFloat(b.price.amount);
  })
);
const totalPrice = computed(
  () => sortedPriceCosts.value.reduce(
    (acc, c) => acc + parseFloat(c.price.amount) / 100,
    0
  )
);
const hasMarginItem = computed(
  () => sortedPriceCosts.value.some((c) => c.type === PriceComponentType.MARGIN)
);
</script>

<template>
    <div class="flex flex-col w-full items-center justify-center">
        <span
            class="w-full text-xs md:text-sm font-medium tracking-wider text-header-dark text-center mt-1 mb-4 uppercase"
        >
            {{ $t("simulation.charge.cost_details.title") }}
        </span>
        <div
            v-if="isFree"
            class="w-full flex items-center justify-center p-6 border border-secondary-gray-disabled rounded-lg bg-white"
        >
            <span
                class="text-badge-positive font-bold text-[15px] md:text-[17px] leading-4 md:leading-5 text-center"
            >
                {{ $t("simulation.charge.cost_details.free_charge") }}
            </span>
        </div>
        <div
            v-else
            class="w-full flex flex-col items-center justify-center h-[260px] md:h-[330px] p-4 md:p-6 self-stretch border border-secondary-gray-disabled rounded-2xl bg-badge-neutral"
        >
            <span
                v-if="isLoading"
                class="text-[15px] md:text-[17px] text-gray-disabled font-medium leading-4 md:leading-5 tracking-[-0.17px] w-full text-center"
            >
                {{ $t("simulation.charge.cost_details.empty_data") }}
            </span>
            <CostLine
                v-for="(component, index) in sortedPriceCosts"
                v-else
                :key="component.type"
                :item="component"
                :total-price
                :index
                :length="sortedPriceCosts.length"
                :is-disabled
                :is-boost
                :has-margin-item
            />
        </div>
    </div>
</template>
